import { useDocumentTitle } from "@/lib/use-document-title";
import { LegalLayout } from "@/components/LegalLayout";

export default function AngerrattPage() {
  useDocumentTitle("Ångerrätt — Lagamobilen Access");
  return (
    <LegalLayout title="Information om ångerrätt" updated="Senast uppdaterad 3 juni 2026">
      <section>
        <h2>Din ångerrätt</h2>
        <p>
          Enligt lagen om distansavtal och avtal utanför affärslokaler (2005:59) har du som
          konsument rätt att frånträda detta avtal inom 14 dagar utan att ange något skäl.
        </p>
        <p>
          Ångerfristen löper ut 14 dagar efter den dag då avtalet ingicks. Vill du utöva
          ångerrätten ska du skicka ett klart och tydligt meddelande om ditt beslut att frånträda
          avtalet. Du kan:
        </p>
        <ul>
          <li>använda ångerfunktionen i medlemsportalen,</li>
          <li>
            mejla <a href="mailto:access@lagamobilen.se">access@lagamobilen.se</a>, eller
          </li>
          <li>använda standardblanketten längst ned.</li>
        </ul>
        <p>
          För att hinna utöva ångerrätten i tid räcker det att du skickar ditt meddelande innan
          ångerfristen löpt ut.
        </p>
      </section>

      <section>
        <h2>Viktigt – när ångerrätten upphör</h2>
        <p>
          Medlemskapet är en tjänst som börjar utföras direkt vid tecknandet. Vid köpet samtycker
          du uttryckligen till att tjänsten påbörjas omedelbart och bekräftar att du förstår att
          ångerrätten upphör när tjänsten har börjat nyttjas.
        </p>
        <p>
          Det innebär att om du har nyttjat en medlemsförmån har du inte längre rätt att ångra
          köpet. Har du ännu inte nyttjat någon förmån kan du ångra köpet inom 14 dagar och få
          betalt belopp återbetalat.
        </p>
      </section>

      <section>
        <h2>Verkan av att utöva ångerrätten</h2>
        <p>
          Om du frånträder avtalet i tid betalar vi tillbaka det belopp du betalat, utan onödigt
          dröjsmål och senast 14 dagar från det att vi mottagit din anmälan. Återbetalning sker via
          samma betalningsmetod som du använde vid köpet.
        </p>
      </section>

      <section>
        <h2>Ångerblankett</h2>
        <p className="text-sm text-muted-foreground mb-4">
          (Fyll i och skicka tillbaka endast om du vill frånträda avtalet.)
        </p>
        <div className="cancellation-form">
          <p className="font-semibold mb-1">ResQ My Device AB</p>
          <p className="text-sm text-muted-foreground mb-4">
            Hyllie stationsväg 10, 215 32 Malmö ·{" "}
            <a href="mailto:access@lagamobilen.se">access@lagamobilen.se</a>
          </p>
          <p className="mb-4">
            Jag meddelar härmed att jag frånträder mitt avtal om medlemskap Lagamobilen Access:
          </p>
          <div className="form-fields">
            <div className="form-field">
              <span className="form-label">Beställt den</span>
              <span className="form-line" />
            </div>
            <div className="form-field">
              <span className="form-label">Namn</span>
              <span className="form-line" />
            </div>
            <div className="form-field">
              <span className="form-label">Adress</span>
              <span className="form-line" />
            </div>
            <div className="form-field">
              <span className="form-label">E-post / telefon</span>
              <span className="form-line" />
            </div>
            <div className="form-field">
              <span className="form-label">Datum</span>
              <span className="form-line" />
            </div>
            <div className="form-field">
              <span className="form-label">Underskrift (endast vid pappersblankett)</span>
              <span className="form-line" />
            </div>
          </div>
        </div>
      </section>
    </LegalLayout>
  );
}
